import React from 'react';
import { Button, Form, Row } from 'react-bootstrap';

export function AdminFilter({ handleChanges, handleClicks }: any) {
    return (
        <Form>
            <Row style={{ rowGap: '18px' }}>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="User ID"
                        className="autocomplete-input"
                        name="id"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-2 col-6">
                    <Form.Control
                        placeholder="name,email"
                        className="autocomplete-input"
                        name="search"
                        onChange={handleChanges}
                    />
                </div>
            </Row>
            <div className="d-flex gap-2">
                <Button className="mt-4" onClick={() => handleClicks()}>
                    Search
                </Button>
            </div>
        </Form>
    );
}
